import EventsMultiStateSwitch from './EventsMultiStateSwitch';

export default EventsMultiStateSwitch;
